import { TOKEN_KEY } from "../constants/auth";

// return the token from the local storage
export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY) || null;
};

// remove the token and user from the local storage
export const removeCurrentSession = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};

// set the token and user to the local storage
export const setUserSession = (token: string, tokenType: string): void => {
  localStorage.setItem(TOKEN_KEY, `${tokenType} ${token}`);
};
